/* 曹操傳・第 3 章：收青州兵（初平三年，192）
 * 史實：《三國志·武帝紀》青州黃巾百萬人入兗州，曹操「追黃巾至濟北，乞降。冬，受降卒三十餘萬，男女百餘萬口，收其精銳者，號爲青州兵」。
 * 流程：黃巾人多勢眾，硬打打不完。削他們的「士氣」：斬渠帥、燒營中的黃旗、擊殺落單的黃巾都會讓士氣下降；
 *       士氣歸零，黃巾乞降，還活著的都收編成青州兵。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, ally, allyTick, TROOPS } from '../kit.ts';
import { CAMPS } from '../maps/jibei.ts';

const LV = 6, START = [1200, 4200];

export default {
  id: 'caocao-3', map: 'jibei', hero: 'caocao',
  title: '第 3 章　收青州兵', year: '初平三年（192）',
  brief: {
    quote: [{ text: '追黃巾至濟北，乞降。冬，受降卒三十餘萬，男女百餘萬口，收其精銳者，號爲青州兵。', src: '《三國志·魏書·武帝紀》' }],
    text: '青州黃巾百萬之眾湧入兗州，殺了兗州刺史劉岱。曹操被推為兗州牧，兵少，只能用奇兵一點一點削弱黃巾。',
    goals: ['斬渠帥、燒黃旗，削弱黃巾的士氣', '黃巾乞降，收編青州兵'],
  },
  words: { ally: '曹軍', foe: '黃巾' },
  stars: [
    { text: '收編 25 人以上的青州兵', ok: (m) => m.vars.got >= 25 },
    { text: '曹軍折損不超過 4 人', ok: (m) => m.stats.lost <= 4 },
    { text: '四分鐘內讓黃巾乞降', ok: (m) => m.vars.doneT != null && m.vars.doneT < 240 },
  ],
  steps: [
    { // 1. 削士氣
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = START[0]; me.y = START[1];
        V.morale = 100; V.t0 = w.t; V.kills = 0;
        V.men = Array.from({ length: 8 }, (_, i) => { const u = m.recruit(me.x - 80 - (i % 4) * 50, me.y - 60 + Math.floor(i / 4) * 90, '曹軍'); u.spec = TROOPS.wei; m.join(u, me); return u; });
        V.dun = ally(w, 'xiahoudun', me.x + 100, me.y - 80, LV);
        V.camps = CAMPS.map(([x, y], k) => {
          const chief = m.foe('bandit', x, y - 40, { name: '黃巾渠帥', hp: 1300, maxHp: 1300, atk: 38 });
          const crowd = m.camp(x, y, [['huangjin', 12]], 380);
          m.mark('c' + k, x, y, '黃巾大營');
          return { x, y, chief, crowd, flag: false };
        });
        // 營外遊蕩的黃巾
        V.roam = Array.from({ length: 12 }, (_, i) => { const a = i * 0.9, u = m.foe('huangjin', 4200 + Math.cos(a) * 1300, 2700 + Math.sin(a) * 900); m.patrol(u, [[u.x, u.y], [u.x + 400, u.y + 200]]); return u; });
        V.all = V.camps.flatMap((c) => [c.chief, ...c.crowd]).concat(V.roam);
        m.line('曹操', '黃巾雖眾，烏合之眾而已。斬其渠帥、燒其旗號，必能令其自潰。');
        m.after(4, () => m.line('提示', '斬渠帥、站在大營中央燒掉黃旗，都能大幅削弱黃巾的士氣；士氣歸零，他們就會投降。'));
        m.obj('morale', '');
      },
      tick(m, w) {
        const me = w.player, V = m.vars;
        // 士氣：每殺一個 -1、渠帥 -20、燒旗 -15
        const dead = V.all.filter((u) => !u.alive && !u.tallied);
        for (const u of dead) { u.tallied = true; V.morale -= u.name === '黃巾渠帥' ? 20 : 1; if (u.name === '黃巾渠帥') m.big('斬渠帥！'); }
        V.camps.forEach((c, k) => {
          if (c.flag) return;
          m.chanAt(me, 'flag' + k, c.x, c.y, 200, 2.5, '燒黃旗', () => { c.flag = true; V.morale -= 15; m.unmark('c' + k); m.fire(c.x, c.y, { dps: 40, life: 8 }); m.big('黃旗燒了！'); });
        });
        V.morale = Math.max(0, V.morale);
        m.get('morale').text = `黃巾的士氣：${Math.round(V.morale)}%`;
        return V.morale <= 0;
      },
    },
    { // 2. 乞降
      enter(m, w) {
        const me = w.player, V = m.vars;
        V.doneT = w.t - V.t0;
        m.done('morale');
        m.big('黃巾乞降！');
        V.got = 0;
        for (const u of V.all) if (u.alive) { u.team = 0; u.recruit = true; u.target = null; u.aggro = null; u.patrol = null; u.home = null; u.spec = TROOPS.wei; u.name = '青州兵'; m.join(u, me); V.got++; }
        m.card('乞降。冬，受降卒三十餘萬，男女百餘萬口，收其精銳者，號爲青州兵。', '《武帝紀》');
        m.after(3, () => m.line('曹操', `好！從今以後，你們就是我的青州兵！（收編 ${V.got} 人）`));
        m.after(7, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    if (!w.player.alive) { m.lose('曹操陣亡'); return; }
    if (m.vars.dun) allyTick(w, m.vars.dun, w.player);
  },
};
